

// import { Toast } from 'antd-mobile';
/**
 * @file 请求统一劫持
 */

import { Axios, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { getAcsToken } from '../../initParis';

export default function (axios: Axios) {
    // 请求拦截器：添加 Acs-Token
    axios.interceptors.request.use(
        async (config: InternalAxiosRequestConfig) => {
            if (config.enableAcsToken) {
                config.headers['Acs-Token'] = await getAcsToken();
            }
            return config;
        },
        (error) => Promise.reject(error)
    );
    axios.interceptors.request.use(
        function (config: InternalAxiosRequestConfig) {
            let contentType = config.headers['Content-Type'];
            // mock
            // config.headers['Baggage'] = 'x-mesh-traffic-lane=feature-nr-homepage';
            if (config.method === 'post') {
                if (!contentType) {
                    contentType = 'application/json';
                }
                config.headers['Content-Type'] = contentType;
            } else {
                if (contentType) {
                    config.headers['Content-Type'] = contentType;
                }
            }
            return config;
        },
    );
    axios.interceptors.response.use(
        function (res: AxiosResponse) {
            const noErrorToastFromServer = !res?.config?.data?.includes('noErrorToast=true');
            const noErrorToastFromFe = !res?.config?.params?.noErrorToast;
            // noErrorToast 不展示toast
            if (res.data.errno !== 0 && noErrorToastFromServer && noErrorToastFromFe) {
                // Toast.show(res.data.errmsg || '操作失败');
            }
            return res;
        },
        function (err) {
            // 接口级错误提示，如404、502
            if (err.message === 'Network Error' || err.code === 'ECONNABORTED') {
                // Toast.show(err.message || '服务错误');
            }
            return Promise.reject(err);
        }
    );
}
